//import * as Turbo from '@hotwired/turbo';
import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

window.addEventListener('mutehovered', e => {
  console.log(e);
});

window.addEventListener('mutedehovered', e => {
  console.log(e);
});

